import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

interface DeleteHistoryConfirmModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

// issue #138: Drive 履歴の .omfz 削除確認。 OverwriteConfirmModal / DiscardConfirmModal と同パターン。
// 破壊的操作なので確定ボタンは赤系。 PDF は別ファイルとして残る旨を明記する。
const DeleteHistoryConfirmModal: React.FC<DeleteHistoryConfirmModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => {
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCancel();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;
  if (typeof document === 'undefined') return null;

  return createPortal(
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="delete-history-confirm-title"
      className="fixed inset-0 z-[200] flex items-center justify-center bg-black/50 backdrop-blur-sm animate-fadein"
      onClick={onCancel}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-2xl shadow-xl p-6 w-[90vw] max-w-md animate-popin"
      >
        <h2 id="delete-history-confirm-title" className="text-lg font-bold text-gray-800 mb-2">
          履歴を削除しますか？
        </h2>
        <p className="text-sm text-gray-600 leading-relaxed mb-6">
          この履歴のファイルを Drive から削除します。PDF はそのまま残ります。よろしいですか？
        </p>
        <div className="flex justify-end gap-2.5">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 rounded-lg text-sm font-semibold text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors"
          >
            キャンセル
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="px-4 py-2 rounded-lg text-sm font-bold text-white bg-red-600 hover:bg-red-700 shadow-sm transition-colors"
          >
            削除する
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default DeleteHistoryConfirmModal;
